import { AgreedTerms } from 'domain/usecases/user/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
  Conflict,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteAgreedTerms implements AgreedTerms {
  private readonly url: string;

  private readonly httpClient: HttpClient<AgreedTerms.Model>;

  constructor(url: string, httClient: HttpClient<AgreedTerms.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  agree = async (params: AgreedTerms.Params): Promise<AgreedTerms.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{userId}', `${params.userId}`),
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      case HttpStatusCode.conflict:
        throw new Conflict();
      default:
        throw new UnexpectedError();
    }
  };
}
